import { apiRequest } from '../utils/axios';
import { DashboardContainerData } from '../models/absorb/dashboard';

export async function fetchDashboard(): Promise<DashboardContainerData[]> {
  return apiRequest('GET', `/my-dashboard`).then((data) => data.containers.containers);
}
